

// Basic sanitize - by removing all tags except allowed ones
export const SanitizeHtml = (html) => {

    // Create a temporary container div to parse the HTML string
    const div = document.createElement('div');

    // Set the inner html as the html that's been passed in
    div.innerHTML = html;

    // Define a whitelist of allowed tag names
    const allowedTags = ['B', 'I', 'U', 'BR', 'P', 'UL', 'LI'];

    // Recursive function to clean a DOM node and its children
    const cleanNode = (node) => {

        // If the node is an element (e.g., <b>, <div>, <script>)
        if (node.nodeType === 1) {

            // Get the tag name (e.g., 'B', 'DIV')
            const tag = node.nodeName;

            // Check if the tag is allowed
            const isAllowed = allowedTags.includes(tag);

            // Loop through the child nodes (in reverse to avoid index shifting)
            for (let i = node.childNodes.length - 1; i >= 0; i--) {

                // Get the current child node
                const child = node.childNodes[i];

                // Clean the child node recursively
                const cleanChild = cleanNode(child);

                // Replace the original child with the cleaned one if it's different
                if (cleanChild !== child) {

                    node.replaceChild(cleanChild, child);

                }

            }

            // If tag is not allowed
            if (!isAllowed) {

                // Create a span wrapper (acts like an unstyled container)
                const span = document.createElement('span');

                // Move all children into the span (unwraps the disallowed element)
                while (node.firstChild) {

                    span.appendChild(node.firstChild);

                }

                // Return the span instead of the disallowed node
                return span;

            }

        }

        // Return the node as-is if it's not an element or is allowed
        return node;

    };

    // Clean each top-level child node in the original container
    const cleanedChildren = Array.from(div.childNodes).map(cleanNode);

    // Create a new container to hold the cleaned sanitized HTML
    const safeDiv = document.createElement('div');

    // Append all cleaned children to the new container
    cleanedChildren.forEach(child => safeDiv.appendChild(child));

    // Return the sanitized HTML string
    return safeDiv.innerHTML;

};